import React from 'react';
import styles from './ArticleListItem.module.css';
import Link from 'next/link';
import { Api } from 'api/znaniya-server';

type Props = {
  article: Api.GetArticles200Response.Article;
  discipline_kind: string;
};

const ArticleListItem = ({ article, discipline_kind }: Props) => {
  return (
    <div className={styles.wrapper}>
      <Link href={`/${discipline_kind}/${article.kind}`}>
        <a className={styles.link}>{article.name}</a>
      </Link>
    </div>
  );
};

export default ArticleListItem;
